import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M21 10.702v1.379c0 1.19-.798 1.916-1.756 1.93-1.568.015-2.221 1.147-1.452 2.527.464.841.232 1.901-.595 2.38l-1.568.886a1.496 1.496 0 0 1-2.047-.537l-.101-.175c-.813-1.408-2.149-1.408-2.962 0l-.101.175a1.496 1.496 0 0 1-2.047.537l-1.568-.886c-.842-.479-1.074-1.539-.595-2.38.77-1.38.116-2.497-1.452-2.526-.958 0-1.756-.74-1.756-1.713v-1.38c0-1.19.798-1.915 1.756-1.93 1.568-.014 2.221-1.147 1.452-2.526-.464-.842-.232-1.901.595-2.38l1.568-.886a1.496 1.496 0 0 1 2.047.537l.101.174c.813 1.408 2.149 1.408 2.962 0l.101-.174a1.496 1.496 0 0 1 2.047-.537l1.568.886c.842.479 1.074 1.538.595 2.38-.77 1.38-.116 2.497 1.451 2.526.959 0 1.757.74 1.757 1.713"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M11.912 8.993a2.706 2.706 0 0 0-2.702 2.708 2.706 2.706 0 0 0 2.702 2.708 2.706 2.706 0 0 0 2.701-2.708 2.706 2.706 0 0 0-2.701-2.708"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnSettings;
